export const GOOGLE_MAPS_API_KEY = 'AIzaSyDKkpKwsK6XGWGvZ2vCo9IpBmQkwExtb0E';
